import React, { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import superuserService from "@/services/superadminService";
import {
  Button,
  Card,
  Col,
  Row,
  Select,
  Skeleton,
  Space,
  Statistic,
  Switch,
  Tooltip,
  Typography,
} from "antd";
import "./chart.css";
import shipimg from "@/assets/shipimg.svg";
import ChartComments from "./ChartComments";
import CardChart from "./Charts/Cardchart/CardChart";
import BarChart from "./Charts/Barchart/BarChart";
import LineChart from "./Charts/LineChart/LineChart";
import ScatterChart from "./Charts/Scatterchart/ScatterChart";
import PieChart from "./Charts/Piecharts/PieChart";
import DonutChart from "./Charts/Piecharts/DonutChart";
import RegressionChart from "./Charts/Regressionchart/RegressionChart";
import MixedChart from "./Charts/Mixedchart/MixedChart";
import AreaChart from "./Charts/Areachart/AreaChart";
import ScatterLine from "./Charts/Scatterchart/ScatterLine";
import PolynomialRegressionChart from "./Charts/Regressionchart/Polynomialchart";
import {
  benchCategory,
  chartcolors,
  createYaxisAnnotations,
  yearcategories,
} from "./Charts/Chartutils";
import Wordmapchart from "./Charts/Worldmapchart";
import { useParams } from "react-router-dom";
import MonthlyBarChart from "./Charts/Barchart/MonthlyBarchart";
import DatewiseRegression from "./Charts/Regressionchart/DatebasedRegression";
import { MessageCircleQuestion, MessageSquare, Plus, Table2 } from "lucide-react";
import { Table, Tag } from "antd";
import StatSummary from "./Charts/StatSummary";
import MarineGaugeChart from "./Charts/Gaugechart/CustomGauge";
import ListChart from "./Charts/Cardchart/ListChart";
import { useImperativeHandle } from "react";
import HullChart from "./Charts/HullChart";
import StepperBoundariesChart from "./Charts/BenchmarkChart/CIIChart";
import PropellerLayoutCurve from "./Charts/AdditionalCharts/PropellantChart";
const { Title, Text } = Typography;

const { Option } = Select;

const CommonChart = forwardRef(
  ({ chartinfo, filterData, selectedTopic, classNames, selectedFavourite }, ref) => {


    console.log("selectedTopic", selectedTopic)
    const { date } = filterData;
    const { reportType } = useParams();
    const [getchartid, setchartId] = useState({ chart_id: "", commentlist: [] });
    const [axisData, setAxesData] = useState(null);
    const [chartComments, setChartComments] = useState([]);
    const [listingChart, setListingChart] = useState([]);
    const [chartLoader, setChartLoader] = useState({});
    const [showTable, setShowTable] = useState(false);

    const chartEl = useRef();
    const tableEl = useRef();
    const summaryEl = useRef();
    const commentsEl = useRef();
    // Expose the three refs to parent via `ref`
    useImperativeHandle(ref, () => ({
      chartEl: chartEl.current,
      tableEl: tableEl.current,
      summaryEl: summaryEl.current,
      commentsEl: commentsEl.current,

    }));
    const getYearFromDateRange = (dateRange) => {
      if (dateRange?.start) {
        const startDate = new Date(dateRange?.start);
        return startDate.getFullYear();
      } else {
        return new Date().getFullYear();
      }
    };

    const [chartUtils, setChartutils] = useState({
      category: [],
      series: [],
      colors: null,
      type: "",
      axis: null,
      tabledata: null,
      chart_period: "daily",
      options: null,
      chart_type: "",

    });
    const [colors, setColors] = useState([]);

    const handleTimePeriodChange = (value) => {
      setChartutils((prev) => ({ ...prev, chart_period: value }));
    };

    const fetchTableData = async (getChartinputs) => {
      setChartLoader((prev) => ({
        ...prev,
        [getChartinputs?.chart_id]: true,
      }));
      try {
        let chartData = null;

        if (
          ["LISTCHART", "CARDCHART", "RADIALCHART"].includes(
            getChartinputs?.chart_type
          )
        ) {
          const listpayload = {
            column_list: getChartinputs?.column_list,
            type: getChartinputs?.chart_type,
            date: "",
            filters: { ship_id: filterData?.ship_id },
            eu_noneu: "",
            events: "",
          };

          // Fetch chart data
          chartData = await superuserService.getTableChartdata(listpayload);

          if (chartData?.data) {
            switch (getChartinputs?.chart_type) {
              case "RADIALCHART":
                setListingChart(chartData?.data || []);
                break;

              case "LISTCHART":
                setListingChart(chartData?.data || []);
                break;

              case "CARDCHART":
                setListingChart(chartData?.data || []);
                break;

              default:
                setListingChart([]);
            }
          } else {
            setListingChart([]);
          }
        } else {
          chartData = await superuserService.getTableChartdata({
            ...getChartinputs,
            type: getChartinputs?.chart_type || "",
            filters: filterData,
            chart_axis: getChartinputs?.chart_axis,
          });
          if (chartData) {
            switch (getChartinputs?.chart_type) {
              case "WORLDMAP":
                setAxesData(chartData?.data);
                break;

              case "REGRESSIONCHART":
                setAxesData(chartData || null);
                break;
              case "SINGLEREGRESSIONCHART":
                setAxesData(chartData || null);
                break;

              case "SCATTERLINE":
                setAxesData(chartData || null);
                break;
              case "BENCHMARK":
                setAxesData(chartData || null);
                break
              case "POLYNOMIALCHART":
                setAxesData(chartData?.data || null);
                break;
              case "HULL":
                setAxesData(chartData || null);
                break;
              case "Propellant Chart":
                setAxesData(chartData?.data || null);
                break;
              default:
                setChartComments(chartData?.comments || null);
                setAxesData(chartData || null);
            }
          } else {
            setAxesData([]);
          }
        }
      } catch (error) {
        console.error(
          `Error fetching data for chart ${getChartinputs?.chart_id}:`,
          error
        );
        setListingChart([]);
      } finally {
        setChartLoader((prev) => ({
          ...prev,
          [getChartinputs?.chart_id]: false,
        }));
        setChartutils({
          category: [],
          series: [],
          colors: null,
          type: "",
          axis: null,
          chart_period: "daily",
          options: null,
          chart_type: "",
        });
      }
    };
    useEffect(() => {
      if (chartinfo && Object.keys(chartinfo).length > 0) {
        fetchTableData(chartinfo);
      }
    }, [chartinfo, selectedTopic]);

    const isChartTypeValid = ["PIECHART", "DONETCHART"]?.some(
      (x) => x === chartUtils?.type
    );
    useEffect(() => {
      let timer;
      if (
        chartinfo?.chart_type !== "WORLDMAP" &&
        chartinfo?.chart_type !== "SCATTERLINE" &&
        chartinfo?.chart_type !== "REGRESSIONCHART" &&
        chartinfo?.chart_type !== "SINGLEREGRESSIONCHART" &&
        chartinfo?.chart_type !== "RADIALCHART" &&
        chartinfo?.chart_type !== "POLYNOMIALCHART"
      ) {
        timer = setTimeout(() => {
          if (chartinfo && Object.keys(chartinfo)?.length) {
            let newColors = isChartTypeValid
              ? chartUtils?.series?.map((x) => x?.color)
              : chartUtils?.variant !== "BENCHMARK" && chartUtils?.series
                ? chartUtils?.series?.length && chartUtils?.colors
                  ? chartUtils?.series.map(
                    (series) => chartUtils?.colors[series?.name]
                  )
                  : []
                : // eslint-disable-next-line no-constant-binary-expression
                [] || [];
            setColors(newColors);
          } else {
            setColors([]);
          }
        }, 100);
      }

      return () => clearTimeout(timer);
    }, [chartinfo, chartUtils, isChartTypeValid]);

    const CIIAcolumns = [
      {
        title: "Period",
        dataIndex: "label",
        key: "label",
      },
      {
        title: "CII Rating",
        dataIndex: "color_code",
        key: "color_code",
        render: (label) => {
          const getColorByLabel = (label) => {
            switch (label?.toUpperCase()) {
              case 'A': return '#52c41a';
              case 'B': return '#a0d911';
              case 'C': return '#fadb14';
              case 'D': return '#fa8c16';
              case 'E': return '#f5222d';
              default: return '#d9d9d9'; // fallback
            }
          };

          return (
            <div className="d-flex">
              <div
                style={{
                  width: 20,
                  height: 20,
                  backgroundColor: getColorByLabel(label),
                  borderRadius: 4,
                  border: '1px solid #ccc'
                }}
              /> <span className="ms-2">{label?.toUpperCase()}</span>
            </div>
          );
        }
      },
      {
        title: "Required CII",
        dataIndex: "ciiRequired",
        key: "ciiRequired",
      },
      {
        title: "Attained CII",
        dataIndex: "formulaValue",
        key: "formulaValue",
      },
    ];
    const getProperlable = (itm) => {
      const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
      if (months?.find(x => x == itm?.label))
        return `${itm?.label} ${itm?.year}`

      else
        return itm.label
    }

    const roundOffTableData = chartUtils?.tabledata?.map((item) => ({
      ...item,
      ciiRequired: item?.ciiRequired ? item?.ciiRequired.toFixed(3) : 0,
      formulaValue: item?.formulaValue ? item?.formulaValue?.toFixed(3) : 0,
      aggregatedValue: item?.aggregatedValue ? item?.aggregatedValue?.toFixed(3) : 0,
      label: getProperlable(item)
    }));
    useEffect(() => {
      if (!selectedTopic) return;
      let categories = [];
      let seriesinfo = [];
      let colors = null;
      let yaxisdata = [];
      if (axisData) {
        const mainaxisData = axisData?.data;
        if (!chartinfo?.chart_meta?.noDatebased) {


          categories = mainaxisData?.date ? mainaxisData?.date?.map((date) =>
            new Date(date).toLocaleDateString("en-CA")
          ) : [];
        }

        if (
          chartinfo?.chart_type === "DONETCHART" ||
          chartinfo?.chart_type === "PIECHART"
        ) {
          seriesinfo = mainaxisData?.series?.length
            ? mainaxisData?.series.map((item) => ({
              name: item?.key,
              data: [item?.value],
              color: item?.color,
            }))
            : [];
        } else if (chartinfo.chart_type === "SCATTERCHART") {
          seriesinfo =
            mainaxisData &&
            Object.keys(mainaxisData)
              .filter((key) => key !== "date" && key !== "series")
              .map((key) => ({
                name: key,
                data: mainaxisData?.date?.map((date, index) => ({
                  x: date,
                  y: mainaxisData[key][index]?.filter((x) => x !== null) || 0,
                })),
              }));
        }

        else if (chartinfo.chart_type === "BENCHMARK") {
          const tabvleresult = axisData?.data?.length ? axisData?.data?.find(x => x?.name === "result")?.value : null;
          setChartutils({
            category: axisData?.years,
            series: axisData?.data,
            tabledata: axisData?.tabledata?.length ? axisData?.tabledata : [],
          });

        } else if (chartinfo.chart_type === "MIXEDCHART") {
          seriesinfo = mainaxisData?.series;
          colors = axisData?.colors;
        }
        else if (chartinfo.chart_type === "HULL") {
          setChartutils({ series: axisData?.data, category: axisData.boundaries })
          return
        }
        else if (chartinfo.chart_type === "Propellant Chart") {
          setChartutils({ series: axisData })
          return
        }
        else if (chartinfo?.chart_type === "SCATTERLINE") {
          seriesinfo = mainaxisData;
        } else if (axisData && chartinfo?.chart_type === "REGRESSIONCHART") {
          setChartutils({
            axis: chartinfo?.chart_axis,
            series: axisData?.data,
            chart_type: "REGRESSIONCHART",
            colors: axisData?.colors,
          });
        } else if (chartinfo?.chart_type === "SINGLEREGRESSIONCHART") {
          setChartutils({
            axis: axisData?.axis,
            series: axisData?.data,
            chart_type: "SINGLEREGRESSIONCHART",
            name: axisData?.name,
            colors: axisData?.colors,
          });
        } else if (axisData && chartinfo?.chart_type === "WORLDMAP") {
          setChartutils({
            chart_type: "WORLDMAP",
            series: axisData,
          });
        } else {
          seriesinfo =
            mainaxisData && Object.keys(mainaxisData)?.length
              ? Object.keys(mainaxisData)
                .filter((key) => key !== "date" && key !== "series")
                .map((key) => ({
                  name: key,
                  data:
                    Array.isArray(mainaxisData[key]) &&
                      mainaxisData[key]?.length
                      ? mainaxisData[key].filter((x) => x !== null)
                      : [],
                }))
              : null;

          colors = axisData?.colors;
        }
      }

      if (axisData && reportType === "MONTHLY") {
        setChartutils({
          axis: chartinfo?.chart_axis,
          type: chartinfo?.chart_meta,
          chart_type: chartinfo?.chart_type,
          series: axisData,
        });
        return;
      }
      if (axisData && chartinfo?.chart_type === "POLYNOMIALCHART") {
        setChartutils({
          axis: chartinfo?.chart_axis,
          type: chartinfo?.chart_meta,
          chart_type: "POLYNOMIALCHART",
          series: axisData,
        });
      } else if (
        axisData &&
        chartinfo &&
        chartinfo?.chart_type !== "BENCHMARK" &&
        chartinfo?.chart_type !== "REGRESSIONCHART" &&
        chartinfo?.chart_type !== "SINGLEREGRESSIONCHART" &&
        chartinfo?.chart_type !== "WORLDMAP"
      ) {
        setChartutils((prev) => ({
          ...prev,
          categorywise: axisData?.categorywise || null,
          category: categories,
          series:
            axisData?.options?.calcMethod === "DEVIATION"
              ? axisData?.data?.series
              : seriesinfo,
          axis: axisData?.axis,
          colors: colors,
          chart_type: chartinfo?.chart_type,
          type: axisData?.type,
          yaxis: yaxisdata,
          options: axisData?.options,
          tabledata: axisData.tabledata,
          statistics: axisData.statistics,
          chart_period: chartinfo?.chart_period,
        }));
      }
    }, [axisData, chartinfo, date?.value, filterData, selectedTopic]);

    const chartClass = isChartTypeValid ? "pie-chart" : "";
    const handleExpandChart = (chartinfo) => {
      setchartId((prev) => ({
        chart_id: prev.chart_id === chartinfo?.chart_id ? null : chartinfo?.chart_id,
        commentlist: prev.commentlist,
      }));
    };
    const renderDataTable = useMemo(() => {
      if (!axisData?.tabledata || axisData?.tabledata.length === 0) return <Typography.Text className="fs-12 d-flex justify-content-center ">No Data</Typography.Text>

      const columns = Object.keys(axisData?.tabledata[0])
        .filter((key) => key !== "series" && key != "key") // remove the "series" column
        .map((key) => ({
          title: (
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {key.replace(/_/g, " ")}
            </span>
          ),
          dataIndex: key,
          key,
          width: key == "date" ? 75 : 150,
          ellipsis: true,
        }));

      // Split the data into two halves
      const half = Math.ceil(axisData?.tabledata.length / 2);
      const firstHalfData = axisData?.tabledata.slice(0, half);
      const secondHalfData = axisData?.tabledata.slice(half);

      return (
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={12}>
            <Table
              className="rounded-4"
              size="small"
              columns={columns}
              dataSource={firstHalfData}
              pagination={false}
              bordered
            />
          </Col>
          <Col xs={24} lg={12}>
            <Table
              className="rounded-4"
              size="small"
              columns={columns}
              dataSource={secondHalfData}
              pagination={false}
              bordered
            />
          </Col>
        </Row>
      );
    }, [axisData, axisData?.tabledata]);
    const renderedChart = useMemo(() => {
      switch (chartinfo?.chart_type) {
        case "AREACHART":
          return <AreaChart chartUtils={chartUtils} colors={colors} />;
        case "BARCHART":
          return reportType === "DAILY" ? (
            <BarChart chartUtils={chartUtils} colors={colors} />
          ) : (
            <MonthlyBarChart data={chartUtils?.series} chartaxis={chartUtils} />
          );
        case "LINECHART":
          return <LineChart chartUtils={chartUtils} colors={colors} />;
        case "PIECHART":
          return <PieChart chartUtils={chartUtils} colors={colors} />;
        case "SCATTERCHART":
          return <ScatterChart chartUtils={chartUtils} colors={colors} />;
        case "DONETCHART":
          return <DonutChart chartUtils={chartUtils} colors={colors} />;
        case "BENCHMARK":
          return <StepperBoundariesChart chartUtils={axisData} axisData={axisData} />;
        case "REGRESSIONCHART":
          return <RegressionChart chartUtils={chartUtils} />;

        case "SINGLEREGRESSIONCHART":
          return <DatewiseRegression chartUtils={chartUtils} />;

        case "MIXEDCHART":
          return <MixedChart chartUtils={chartUtils} colors={colors} />;
        case "WORLDMAP":
          return <Wordmapchart routeData={chartUtils} />;
        case "SCATTERLINE":
          return <ScatterLine chartUtils={chartUtils} />;
        case "POLYNOMIALCHART":
          return <PolynomialRegressionChart chartUtils={chartUtils} />;
        case "HULL":
          return <HullChart sampleData={chartUtils} />;
        case "Propellant Chart":
          return <PropellerLayoutCurve sampleData={chartUtils?.series} />;

        default:
          return <div>No chart available!</div>;
      }
    }, [chartinfo, chartinfo.chart_type, chartUtils, colors, reportType]);

    const openItem = (type, chartId) => {
      const item = selectedFavourite?.find(x => x?.chart_id === chartId);
      if (item && item.hasOwnProperty(type)) {
        return item[type];
      }
      return undefined;
    };
    useEffect(() => {
      if (selectedFavourite) {

        const defaultValue = openItem("show_table", chartinfo?.chart_id);
        const defaultComments = openItem("show_comments", chartinfo?.chart_id);
        if (defaultValue !== undefined) {
          setShowTable(defaultValue);
        }
        if (defaultComments?.enabled !== undefined) {
          setchartId({ chart_id: chartinfo?.chart_id, commentlist: defaultComments?.selectedComments });
        }
      }
    }, [chartinfo?.chart_id, selectedFavourite]);

    return (
      <div className={`${classNames}`}>
        <div className="row">
          <div className="mixed-chart">
            {chartinfo?.chart_type === "LISTCHART" ? (
              <ListChart listingChart={listingChart} chartinfo={chartinfo} />
            ) : chartinfo?.chart_type === "CARDCHART" ? (
              <CardChart listingChart={listingChart} chartinfo={chartinfo} />
            ) : chartinfo?.chart_type === "RADIALCHART" ? (
              <Row gutter={12}>
                {listingChart?.map((x, index) => (
                  <Col key={index}
                    className="mb-3"
                    span={listingChart?.length === 1 ? 24 : 12}
                  >
                    <Card
                      size="small"
                      title={
                        <Typography.Title
                          level={5}
                          className="  mt-2 ms-2   text-secondary"
                        >
                          {chartinfo?.chart_title}
                        </Typography.Title>
                      }
                    >
                      <MarineGaugeChart
                        type={x?.type}
                        rangeIndex={0}
                        value={x?.value ? (x?.value - 30) : 0}
                      />
                    </Card>
                  </Col>
                ))}
              </Row>
            ) : (
              <>
                {Object.keys(chartLoader)?.length &&
                  chartLoader[chartinfo.chart_id] ? (
                  <>
                    <Skeleton active paragraph={{ rows: 3 }} />
                    <span className="fw-bold d-flex justify-content-center mt-4 align-items-center">
                      Preparing your chart...
                    </span>
                  </>
                ) : chartinfo?.chart_type === "WORLDMAP" ? (
                  <Card
                    size="small"
                    style={{ width: "100%" }}
                    className={`  ${chartClass}`}
                    title={chartinfo?.chart_title}
                  >
                    <div ref={chartEl}  >
                      {renderedChart}
                    </div>
                  </Card>
                ) : chartinfo &&
                  Object.keys(chartinfo).length > 0 &&
                  chartUtils?.series &&
                  chartUtils?.series?.length > 0 &&
                  chartinfo?.chart_type ? (
                  <Card
                    style={{
                      boxShadow: "0 2px 8px rgba(39, 167, 112, 0.15)",
                      marginBottom: "10px",
                    }}
                    bodyStyle={{ padding: "16px" }}
                  >
                    {/* Header Section */}
                  <div
      className="chart-header"
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "10px",
        marginBottom: "12px",
      }}
    >
      {/* LEFT SECTION */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "6px",
          minWidth: 0,
        }}
      >
        <Title level={5} style={{ margin: 0, whiteSpace: "nowrap" }}>
          {chartinfo?.chart_title}
        </Title>
        {chartinfo?.chart_subtitle && (
          <Text
            type="secondary"
            style={{
              fontSize: "13px",
              whiteSpace: "nowrap",
            }}
          >
            {chartinfo?.chart_subtitle}
          </Text>
        )}
        {chartinfo?.descriptions && (
          <Tooltip title={chartinfo?.descriptions}>
            <MessageCircleQuestion
              size={18}
              style={{ color: "#0C9679", cursor: "pointer" }}
            />
          </Tooltip>
        )}
      </div>

      {/* RIGHT SECTION */}
      <div
        className="chart-header-controls"
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "12px",
          justifyContent: "flex-end",
        }}
      >
        {chartinfo?.chart_type !== "HULL" && (
          <Space size="middle" wrap>
            <Space>
              <Text style={{ fontSize: "13px", color: "#8c8c8c" }}>
                Show Table
              </Text>
              <Switch
                checked={showTable}
                onChange={setShowTable}
                size="small"
              />
            </Space>
            <Space>
              <Text style={{ fontSize: "13px", color: "#8c8c8c" }}>
                Show Comments
              </Text>
              <Switch
                checked={getchartid?.chart_id}
                onClick={() => handleExpandChart(chartinfo)}
                size="small"
              />
            </Space>
          </Space>
        )}

        {(chartinfo?.chart_type === "BARCHART" ||
          chartinfo?.chart_type === "AREACHART" ||
          chartinfo?.chart_type === "LINECHART") && (
          <Select
            defaultValue="daily"
            size="small"
            style={{ width: 120 }}
            onChange={handleTimePeriodChange}
          >
            <Option value="daily">Daily</Option>
            <Option value="weekly">Weekly</Option>
            <Option value="monthly">Monthly</Option>
          </Select>
        )}
      </div>
    </div>


                    {axisData?.statistics
                      ? Object.keys(axisData?.statistics)?.length ? (
                        <div ref={summaryEl}>
                          <StatSummary statistics={axisData?.statistics} />
                        </div>
                      ) : ""
                      : ""}

                    <Card size="small" ref={chartEl}    >
                      <Col   >
                        {renderedChart}
                      </Col>
                    </Card>

                    <Row gutter={12} className="mt-3">
                      {showTable && (
                        <Col span={24}>
                          <Card
                            ref={tableEl}
                            size="small"
                            title={
                              <Space size="small">
                                <Table2 style={{ fontSize: "14px" }} />
                                <span style={{ fontSize: "14px" }}>
                                  {chartinfo?.chart_title} Data
                                </span>
                              </Space>
                            }
                            extra={
                              <Text type="secondary" style={{ fontSize: "12px" }}>
                                Total: records ({axisData?.tabledata && axisData?.tabledata.length})
                              </Text>
                            }
                          >
                            {chartinfo?.chart_type === "BENCHMARK" ? (
                              <Table
                                size="small"
                                bordered
                                scroll={{
                                  x: "max-content",
                                  y: 300,
                                }}
                                className="custom-table-headers rounded-4"
                                dataSource={roundOffTableData}
                                columns={CIIAcolumns}
                              />
                            ) : (

                              renderDataTable

                            )}
                          </Card>
                        </Col>
                      )}
                      <Col span={24}>
                        <div className="p-2">
                          <div
                            style={{
                              minHeight: showTable ? "180px" : "40px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >

                            {getchartid?.chart_id === chartinfo?.chart_id ? (
                              <ChartComments
                                getchartid={getchartid}
                                chartcomments={chartComments}
                                ref={commentsEl}
                              />
                            ) : (
                              <Typography.Text type="secondary">
                                No Comments
                              </Typography.Text>
                            )}
                          </div></div>
                      </Col>
                    </Row>
                  </Card>
                ) : (
                  ""
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  });

export default CommonChart;
